import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsMQ: CultureInfo = {
  name: 'es-MQ',
  displayName: 'español (Martinica)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-MQ',
  parent: CultureInfoEs
};
